var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('edit-order-take-over-all-entries',{attrs:{"inputLines":_vm.inputLines}}),_c('edit-order-collection-input-container',{attrs:{"inputLines":_vm.inputLines,"split-view":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }